<template>
  <div
    ref="dropdownComponent"
    class="inline-block"
    :class="{ 'pointer-events-none cursor-not-allowed': disabled }"
  >
    <span ref="referenceEl" @click="changeShow">
      <slot :active="show" />
    </span>
    <transition
      enter-active-class="transition ease-out duration-300 transform"
      enter-from-class="opacity-0 -translate-y-4"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="ease-in duration-200"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-4"
    >
      <div v-if="show" ref="floatingEl" class="absolute z-10 max-w-max">
        <div
          class="min-w-40 mt-1 rounded border border-solid border-neutral-100 bg-white text-black shadow-lg dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-200"
        >
          <slot name="content" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { onClickOutside } from '@vueuse/core'

import {computePosition, Placement, autoUpdate} from '@floating-ui/vue'

const props = withDefaults(
  defineProps<{
    position?: Placement
    disabled?: boolean
  }>(),
  { position: 'bottom' }
)

const dropdownComponent = ref()
const show = ref(false)
const referenceEl = ref<HTMLSpanElement>()
const floatingEl = ref()
const cleanup = ref()

const updatePosition = () => {
  computePosition(referenceEl.value, floatingEl.value, {
    placement: props.position
  }).then(({x, y}) => {
    Object.assign(floatingEl.value.style, {
      left: `${x}px`,
      top: `${y}px`,
    });
  });
}

watch(
  () => floatingEl.value,
  (nVal) => {
    if (nVal) {
      cleanup.value = autoUpdate(
        referenceEl.value,
        floatingEl.value,
        updatePosition,
        {elementResize: false}
      )
    } 
  }
)

const changeShow = () => {
  cleanup.value?.()
  show.value = !show.value
}

onClickOutside(dropdownComponent, () => {
  cleanup.value?.()
  show.value = false
})
</script>
